import React from 'react';
import { Helmet } from 'react-helmet';
import useToggle from '../../Hooks/useToggle';
import heroThumb from '../../assets/images/features-thumb.webp';
import BackToTop from '../BackToTop';
import FooterHomeThree from '../Footer/FooterHomeThree';
import HeaderNews from '../Header/HeaderNews';
import HeroNews from '../Header/HeroNews';
import Drawer from '../Mobile/Drawer';
import ServicesAbout from './ServicesAbout';

function AboutUsTwo() {
    const [drawer, drawerAction] = useToggle(false);
    return (
        <>
            <Helmet>
                <meta
                    name="description"
                    content="Kapp MicroSystems has built OTO in Kigali since 2015 for hotels, restaurants, bars and shops. Meet the team and see what OTO runs."
                />
                <meta property="og:image" content={heroThumb} />
                <title>About OTO by Kapp | Business Software Made in Rwanda</title>
            </Helmet>
            <Drawer drawer={drawer} action={drawerAction.toggle} />
            <HeaderNews action={drawerAction.toggle} />
            <main>
                <HeroNews
                    title="About Us"
                    breadcrumb={[
                        { link: '/', title: 'Home' },
                        { link: '/about', title: 'About us' },
                    ]}
                />

                <div className="container pt-90 pb-90">
                    <p style={{ fontSize: '18px', lineHeight: '29px' }}>
                        <a href="https://kapp.rw/about">Our company (Kapp)</a> has over 8 years of
                        experience in developing software solutions. During this time, we have
                        worked with a wide range of clients in various industries, from small large
                        businesses. This experience has allowed us to refine our products and
                        services to meet the specific needs of our clients, and to stay up-to-date
                        with the latest industry trends and technologies. We are proud of our 8-year
                        track record of delivering innovative, user-friendly, and reliable software
                        solutions to our clients.
                    </p>
                </div>
                <ServicesAbout />

                <div className="container pt-90 pb-100">
                    <div className="row">
                        <div className="col-lg-6 col-12">
                            <h3 className="mb-3">Our Mission</h3>
                            <p>
                                Our mission is to empower businesses with the tools they need to
                                succeed in their respective industries. We aim to provide
                                innovative, user-friendly, and scalable software solutions that help
                                our clients streamline their operations, enhance their customer
                                experiences, and boost their bottom lines. We are committed to
                                delivering exceptional customer service and fostering long-term
                                partnerships with our clients.
                            </p>
                        </div>

                        <div className="col-lg-6 col-12">
                            <h3 className="mb-3">Our Vision</h3>
                            <p>
                                Our vision is to be the leading provider of business software
                                solutions, recognized for our innovative products, exceptional
                                customer service, and commitment to client success. We strive to be
                                at the forefront of technology trends and to continuously improve
                                our products and services to meet the evolving needs of the
                                businesses in various industries. Our goal is to help our clients
                                achieve their full potential and to drive innovation and growth.
                            </p>
                        </div>
                    </div>
                </div>
            </main>
            <FooterHomeThree className="appie-footer-about-area" />
            <BackToTop />
        </>
    );
}

export default AboutUsTwo;
